import { render, staticRenderFns } from "./FeedBackModal.vue?vue&type=template&id=251f3c4c&"
import script from "./FeedBackModal.vue?vue&type=script&lang=js&"
export * from "./FeedBackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports